import axios from 'axios'

class SymptomCheckerService {
  constructor() {
    this.baseUrl = '/api/v1/'
  }

  getInfermedicaURL(data) {
    return axios.get(`${this.baseUrl}users/get_symptom_checker_token/`)
  }
}

export const symptomCheckerService = new SymptomCheckerService()
